"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isComboSnapshotProtected = isComboSnapshotProtected;
exports.isActiveComboSnapshot = isActiveComboSnapshot;
const isComboProfitable_1 = require("./isComboProfitable");
function isComboSnapshotProtected(snapshot) {
    return isActiveComboSnapshot(snapshot) || new Date(snapshot.protectOrdersUntil) > new Date();
}
function isActiveComboSnapshot(snapshot) {
    return snapshot.isAvailable && snapshot.isApproved !== false && (0, isComboProfitable_1.isComboProfitable)(snapshot);
}
//# sourceMappingURL=isComboSnapshotProtected.js.map